import { Dialog } from "components/dialog/Dialog";
import { DialogFooter } from "components/dialog/DialogFooter/DialogFooter";
import { DialogHeader } from "components/dialog/DialogHeader/DialogHeader";
import { DialogBody } from "components/dialog/DialogMain/DialogBody/DialogBody";
import { DialogCaption } from "components/dialog/DialogMain/DialogCaption/DialogCaption";
import { DialogMain } from "components/dialog/DialogMain/DialogMain";
import React from "react";
import useDialogStore from "stores/useDialogStore";

export default function CommonDialog() {
  const { dialogForm } = useDialogStore();

  return dialogForm ? (
    <Dialog
      size={dialogForm.size}
      state={dialogForm.state}
      preventClose={dialogForm.preventClose}
    >
      <DialogHeader>{dialogForm.title}</DialogHeader>
      <DialogMain>
        <DialogBody icon={dialogForm.body.icon}>
          <span className="pre-wrap">{dialogForm.body.content}</span>
        </DialogBody>
        {dialogForm.caption && (
          <DialogCaption icon={dialogForm.caption.icon}>
            <span className="pre-wrap">{dialogForm.caption.content}</span>
          </DialogCaption>
        )}
      </DialogMain>
      <DialogFooter
        button={dialogForm.button}
        secondButton={dialogForm.secondButton}
      />
    </Dialog>
  ) : (
    <></>
  );
}
